module.exports = __webpack_public_path__ + "static/media/400117_01.ba699875.png";